export const JACKPOT_INVENTORY_ITEM_PRICE = [
  25000, 75000, 150000, 75000, 50000, 175000, 125000, 425000, 350000, 1500000,
];
